import itemsPage from './items-page';
export default itemsPage;